require("!!C:\\svn\\trunk\\node_modules\\script-loader\\addScript.js")(require("!!C:\\svn\\trunk\\node_modules\\raw-loader\\index.js!C:\\svn\\trunk\\node_modules\\jquery-migrate\\dist\\jquery-migrate.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/jquery-migrate/dist/jquery-migrate.min.js
// module id = 78
// module chunks = 0